<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="default"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="selectedUrl ? `/request/${inputs.id}` : '/request'"
      >
        <div class="row">
          <div
            class="col-12"
            v-if="
              ['OICC', 'OEYC', 'OENY', 'OCLN', 'OINSP'].includes(this.activity)
            "
          >
            <div class="form-group">
              <label>{{
                ["OICC"].includes(this.activity)
                  ? "Campo de ensayo"
                  : ["OEYC", "OENY"].includes(this.activity)
                  ? "Área metrológica/Campo"
                  : ["OCLN"].includes(this.activity)
                  ? "Campo de análisis"
                  : ["OINSP"].includes(this.activity)
                  ? "Tipo de inspección o metodología"
                  : "Nivel 3"
              }}</label>
              <app-input
                type="select"
                v-model="inputs.level3"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.scopes.level3,
                ]"
              />
            </div>
          </div>

          <div class="col-12" v-if="['OICC', 'OCLN'].includes(this.activity)">
            <div class="form-group">
              <label>{{
                ["OICC", "OCLN"].includes(this.activity) ? "Técnica" : "Nivel 4"
              }}</label>
              <app-input
                type="select"
                v-model="inputs.level4"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.scopes.level4,
                ]"
              />
            </div>
          </div>

          <div
            class="col-12"
            v-if="
              [
                'OICC',
                'OEYC',
                'OENY',
                'OCLN',
                'OCPR',
                'OCPE',
                'OINSP',
                'OCSG',
                'CSST',
                'CSIA',
                'CSA',
                'CSGAS',
                'CSEN'
              ].includes(this.activity)
            "
          >
            <div class="form-group">
              <label>{{
                ["OICC"].includes(this.activity)
                  ? "Ensayo"
                  : ["OEYC", "OENY"].includes(this.activity)
                  ? "Magnitud submagnitud"
                  : ["OCLN"].includes(this.activity)
                  ? "Análisis"
                  : ["OCPR"].includes(this.activity)
                  ? "Producto ,proceso o servicio"
                  : ["OCPE"].includes(this.activity)
                  ? "Personal certificado"
                  : ["OINSP"].includes(this.activity)
                  ? "Campo de inspección"
                  : ["OCSG", "CSIA", "CSA", "CSGAS", "CSST", "CSEN"].includes(this.activity)
                  ? "Categoría"
                  : "Nivel 5"
              }}</label>
              <app-input
                type="select"
                v-model="inputs.level5"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.scopes.level5,
                ]"
              />
            </div>
          </div>

          <div
            class="col-12"
            v-if="
              [
                'OICC',
                'OEYC',
                'OENY',
                'OCLN',
                'OCPE',
                'OINSP',
                'OCSG',
                'CSST',
                'CSIA',
                'CSA',
                'CSGAS',
                'CSEN'
              ].includes(this.activity)
            "
          >
            <div class="form-group">
              <label>{{
                ["OICC"].includes(this.activity)
                  ? "Producto o material a ensayar"
                  : ["OEYC", "OENY"].includes(this.activity)
                  ? "Tipos  Instrumentos a calibrar"
                  : ["OCLN"].includes(this.activity)
                  ? "Muestra"
                  : ["OCPR"].includes(this.activity)
                  ? "Categoría de producto, proceso o servicio"
                  : ["OCPE"].includes(this.activity)
                  ? "Categoría de personal"
                  : ["OINSP"].includes(this.activity)
                  ? "Elemento a inspeccionar"
                  : ["OCSG", "CSIA", "CSA", "CSGAS", "CSST", "CSEN"].includes(this.activity)
                  ? "Campo de certificación Sector IAF"
                  : "Nivel 6"
              }}</label>
              <app-input
                type="select"
                v-model="inputs.level6"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.scopes.level6,
                ]"
              />
            </div>
          </div>

          <div
            class="col-12"
            v-if="['OICC', 'OEYC', 'OENY', 'OCLN'].includes(this.activity)"
          >
            <div class="form-group">
              <label>{{
                ["OICC", "OEYC", "OENY"].includes(this.activity)
                  ? "Rango"
                  : ["OCLN"].includes(this.activity)
                  ? "Método"
                  : "Nivel 7"
              }}</label>
              <app-input
                type="text"
                v-model="inputs.level7"
                :required="true"
                :placeholder="
                  'Ingrese el ' +
                  (['OICC', 'OEYC', 'OENY'].includes(this.activity)
                    ? 'rango'
                    : ['OCLN'].includes(this.activity)
                    ? 'método'
                    : 'mivel 7')
                "
              />
            </div>
          </div>

          <div class="col-12" v-if="['OEYC', 'OENY'].includes(this.activity)">
            <div class="form-group">
              <label>{{
                ["OEYC", "OENY"].includes(this.activity)
                  ? "Incertidumbre"
                  : "Nivel 8"
              }}</label>
              <app-input
                type="text"
                v-model="inputs.level8"
                :required="true"
                :placeholder="
                  'Ingrese ' +
                  (['OEYC', 'OENY'].includes(this.activity)
                    ? 'la encertidumbre'
                    : 'el nivel 8')
                "
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    selectedUrl: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        level7: null,
        level8: null,
      },
      scopes: {
        level3: [],
        level4: [],
        level5: [],
        level6: [],
      },
      modalId: "add-edit-modal",
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    this.getData();
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.inputs.acc_app_id = this.$store.state.accreditation.id;
      this.save(this.inputs);
    },
    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },

    getData() {
      this.preloader = true;

      this.axiosGet(
        `request/options?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.scopes = response.data.scopes;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
